import request from "@/http/request"
import {
    score,
    getResultList,
    certificatePrint,
    downloadScoreReview,
    uploadScoreReview,
    getScoreReview,
    getStudentScoreReviewSubCourseInfo,
    getStudentScoreReviewSubCourseDetail
} from '@/http/api'

export const getStudentScoreReviewSubCourseInfoAPI = (data) => {
    return request({
        url: getStudentScoreReviewSubCourseInfo,
        data
    })
}

export const getStudentScoreReviewSubCourseDetailAPI = (data) => {
    return request({
        url: getStudentScoreReviewSubCourseDetail,
        data
    })
}

export const getScoreList = (data) => {
    return request({
        url: score,
        data
    })
}

export const exportScoreList = (data) => {
    return request({
        url: getResultList,
        data
    })
}

export const exportCertificate = (data) => {
    return request({
        url: certificatePrint,
        data
    })
}
export const downRepresen = (data) => {//学生，下载复核表模板
    return request({
        url: downloadScoreReview,
        data
    })
}
export const ScoreReview = (data) => {//，自行上传复核表
    return request({
        url: uploadScoreReview,
        isUpload: true,
        data
    })
}
export const usergetScoreReview = (data) => {
    return request({
        url: getScoreReview,
        data
    })
}